import { createAction, props } from '@ngrx/store';
import { IYears } from '../models/years.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadTaxYearss = createAction('[TaxYears] Load TaxYearss', props<{ request: string }>());

export const loadTaxYearssSuccess = createAction('[TaxYears] Load TaxYearss Success', props<{ response: IYears[] }>());

export const loadTaxYearssFailure = createAction('[TaxYears] Load TaxYearss Failure', props<{ error: IGenericError<ErrorResponse> }>());
